import { apiRequest } from '../utils/apiClient';

// Phase 7: the free-form public Advertisements board (الإعلانات) with replies.
// Backend /api/advertisements/* — gated by ADS_BOARD_ENABLED (router 404s while off).

export interface AdvertisementReply {
  id: string;
  advertisementId: string;
  userId: string;
  message: string;
  createdAt: string;
}

export interface Advertisement {
  id: string;
  userId: string;
  title: string;
  body: string;
  category?: string | null;
  cityId?: string | null;
  status: string; // open | closed | removed
  contactName?: string | null;
  contactPhone?: string | null;
  createdAt: string;
  _count?: { replies: number };
  replies?: AdvertisementReply[];
}

export interface CreateAdInput {
  title: string;
  body: string;
  category?: string;
  cityId?: string;
  contactName?: string;
  contactPhone?: string;
}

// Every /api/advertisements route, reads included, needs a signed-in professional
// account (backend routes/advertisements.js: requireAuth + requireProfessional),
// so the reads take a token like the writes. Without one the API answers 401.
export async function listAdvertisements(
  token: string,
  params?: { status?: string; cityId?: string },
): Promise<Advertisement[]> {
  const qs = new URLSearchParams();
  if (params?.status) qs.set('status', params.status);
  if (params?.cityId) qs.set('cityId', params.cityId);
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  const res = await apiRequest<{ data: Advertisement[] }>(`/advertisements${suffix}`, { token });
  return res.data ?? [];
}

export async function getAdvertisement(token: string, id: string): Promise<Advertisement | null> {
  const res = await apiRequest<{ data: Advertisement }>(`/advertisements/${encodeURIComponent(id)}`, { token });
  return res.data ?? null;
}

export async function createAdvertisement(token: string, input: CreateAdInput): Promise<Advertisement> {
  const res = await apiRequest<{ data: Advertisement }>('/advertisements', { method: 'POST', token, body: input });
  return res.data;
}

export async function replyToAdvertisement(token: string, id: string, message: string): Promise<AdvertisementReply> {
  const res = await apiRequest<{ data: AdvertisementReply }>(`/advertisements/${id}/replies`, { method: 'POST', token, body: { message } });
  return res.data;
}

export async function closeAdvertisement(token: string, id: string): Promise<Advertisement> {
  const res = await apiRequest<{ data: Advertisement }>(`/advertisements/${id}/close`, { method: 'POST', token });
  return res.data;
}
